import { render, staticRenderFns } from "./AdminCategories.vue?vue&type=template&id=bacd0f04&scoped=true&"
import script from "./AdminCategories.vue?vue&type=script&lang=js&"
export * from "./AdminCategories.vue?vue&type=script&lang=js&"
import style1 from "./AdminCategories.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bacd0f04",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bacd0f04')) {
      api.createRecord('bacd0f04', component.options)
    } else {
      api.reload('bacd0f04', component.options)
    }
    module.hot.accept("./AdminCategories.vue?vue&type=template&id=bacd0f04&scoped=true&", function () {
      api.rerender('bacd0f04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/Workspace/AdminPage/AdminCategories.vue"
export default component.exports